import React from 'react'
import Link, { withPrefix } from 'gatsby-link'

//  Components
import caseStudyImageUrl, { ReactComponent as CaseStudyImage } from '../../assets/svg/case-study-hospital-mortality.svg'
import caseStudyNewYorkImageUrl, { ReactComponent as CaseStudyNewYorkImage } from '../../assets/svg/case-study-new-york.svg'
import caseStudyTwoStatesImageUrl, { ReactComponent as CaseStudyTwoStatesImage } from '../../assets/svg/case-study-two-states.svg'
import caseStudyMortalityImageUrl, { ReactComponent as CaseStudyMortalityImage } from '../../assets/svg/case-study-hospital-mortality.svg'
import Button from '../../components/Button/Button.js'

const HospitalMortality = ({ data }) => (
  <div>
    <article className="case_study">
      <div className="section">
        <div className="section__row section__row__2_up section__row__reverse">
        <figure className="section__content section__content__figure case_study__figure">
            <div className="case_study__figure__wrapper">
              <CaseStudyImage />
            </div>
          </figure>
          <div className="section__content section__content__wide">
            <h2 className="title__page__label">A Closer Look:</h2>
            <h1 className="title__page">Hospital Mortality</h1>
            <p>The Scorecard measures deaths within 30 days of hospital discharge among Medicare beneficiaries who were treated for four common conditions: heart attack, stroke, congestive heart failure, and pneumonia. Hospital 30-day mortality rates rose in nearly all states between the two measurement periods reported in the Scorecard, driving the national average from 13.2 percent to 14.1 percent.<sup className="note__link"><a href="#47">47</a></sup> The increase in this rate, which represents a reversal in an earlier improvement trend, appears to be driven by a sharp uptick in mortality among pneumonia patients.</p>
          </div>
        </div>
      </div>
      <hr className="section__divider"/>
      <div className="section">
        <div className="section__row">
          <div className="section__content section__exhibit">
            <h2 className="exhibit__title__block">Hospital mortality has risen among patients admitted for pneumonia</h2>
            <figure>
              <img src={ withPrefix(`/img/exhibits/exhibit-box-2-web.png`) } alt="" />
              <figcaption>
                <p>Data: CMS Hospital Compare, 2014 and 2017 4th Quarter, National-Level Summary Estimates.</p>
              </figcaption>
            </figure>
          </div>
        </div>
      </div>
    </article>
    <div className="section section__case_study__list">
      <div className="section__row section__row__3_up">
        <div className="section__content">
          <figure className="case_study__figure">
            <div className="case_study__figure__wrapper">
              <CaseStudyTwoStatesImage />
            </div>
          </figure>
          <div className="case_study__content">
            <h4 className="case_study__label">A Closer Look:</h4>
            <h3 className="case_study__title">New Hampshire and Maine: Two States Where Medicaid Expansion Is in Flux</h3>
            <Button to="/case-study/medicaid-expansion-in-flux" text="Keep Reading" />
          </div>
        </div>
        <div className="section__content">
          <figure className="case_study__figure">
            <div className="case_study__figure__wrapper">
              <CaseStudyMortalityImage />
            </div>
          </figure>
          <div className="case_study__content">
            <h4 className="case_study__label">A Closer Look:</h4>
            <h3 className="case_study__title">Hospital Mortality</h3>
            <Button to="/case-study/hospital-mortality" text="Keep Reading" />
          </div>
        </div>
        <div className="section__content">
          <figure className="case_study__figure">
            <div className="case_study__figure__wrapper">
              <CaseStudyNewYorkImage />
            </div>
          </figure>
          <div className="case_study__content">
            <h4 className="case_study__label">A Closer Look:</h4>
            <h3 className="case_study__title">New York Moves to Improve</h3>
            <Button to="/case-study/new-york-moves-to-improve" text="Keep Reading" />
          </div>
        </div>
      </div>
    </div>
    <div className="section section__notes">
      <div className="section__row">
        <div className="section__content">
          <ol start="47" style={{counterReset: "item 46"}} className="list__notes">
            <li id="47">The Centers for Medicare and Medicaid Services reports hospital mortality over a three-year time frame.</li>
          </ol>
        </div>
      </div>
    </div>
  </div>
)

export default HospitalMortality

export const query = graphql`
  query HospitalQuery {
    site {
      pathPrefix
    }
  }
`


// WEBPACK FOOTER //
// ./src/pages/case-study/hospital-mortality.js